import { inject } from "mobx-react";
import { BreadcrumbsItem } from "react-breadcrumbs-dynamic";
import { CreateView, ShowView } from "lego-gui-lib";
import React from "react";
import {
  BarringMatrixEntrySchema,
  BarringMatrixEntrySchemaColumns
} from "./schema";
import { observer } from "mobx-react-lite";
import { useHistory } from "react-router";

const injectDataSource = (comp: any) =>
  inject("barringMatrixEntry", "i18n")(observer(comp));

export const CreateBarringMatrixEntry = injectDataSource(
  ({ barringMatrixEntry, i18n, match, ...rest }: any) => {
    const title = i18n.t("common:create", {
      domain: "hns:barringMatrixEntry:domain"
    });
    const baseUrl = match.url;
    const parentTitle = i18n.t("common:edit", {
      domain: "hns:barringMatrix:domain"
    });
    const parentUrl = baseUrl.substring(0, baseUrl.lastIndexOf("/"));
    const id = {
      id: match.params.entryId
    };
    const history = useHistory();

    return (
      <>
        <BreadcrumbsItem to={parentUrl}>{parentTitle}</BreadcrumbsItem>
        <BreadcrumbsItem to={baseUrl}>{title}</BreadcrumbsItem>
        <CreateView
          dataSource={barringMatrixEntry.oneDataSource}
          {...rest}
          title={title}
          fields={BarringMatrixEntrySchemaColumns}
          id={id.id ? id : undefined}
          goBack={() => history.goBack()}
        />
      </>
    );
  }
);

export const ShowBarringMatrixEntry = injectDataSource(
  ({ barringMatrixEntry, i18n, match }: any) => {
    const title = i18n.t("common:edit", {
      domain: "hns:barringMatrixEntry:domain"
    });
    const baseUrl = match.url;
    const id = {
      id: match.params.entryId
    };
    const parentTitle = i18n.t("common:edit", {
      domain: "hns:barringMatrix:domain"
    });
    const parentUrl = baseUrl.substring(0, baseUrl.lastIndexOf("/"));
    const history = useHistory();

    return (
      <>
        <BreadcrumbsItem to={parentUrl}>{parentTitle}</BreadcrumbsItem>
        <BreadcrumbsItem to={baseUrl}>{title}</BreadcrumbsItem>
        <ShowView
          dataSource={barringMatrixEntry.oneDataSource}
          title={title}
          fields={BarringMatrixEntrySchema}
          id={id}
          goBack={() => history.goBack()}
        />
      </>
    );
  }
);
